import { Component } from '@angular/core';

@Component({
    selector: 'op-ancillary-service-content',
    templateUrl: './ancillary-service-content.component.html'
})
export class AncillaryServiceContentComponent { 
}
